import axios from 'axios'

const API_URL = '/api/auth/'

/**
 * Logs the user out by invalidating the server-side session.
 * The server will clear the httpOnly session cookie.
 */
export async function logoutUser(): Promise<void> {
  try {
    await fetch(`${API_URL}logout`, { method: 'POST' })
  }
  catch {
    // Best-effort: even if the call fails, the UI will redirect to login
  }
}

export async function authLogin(username: string, password: string) {
  const response = await axios.post(`${API_URL}login`, {
    username,
    password,
  })

  if (response.status === 201) {
    // The server sets the httpOnly session cookie — no token storage needed here.
    // access_token is returned in the body for API client compatibility.
    return response.data
  }
}

export async function authAutoLogin(token: string) {
  const response = await axios.post(`${API_URL}auto-login`, {
    token,
  })

  if (response.status === 201) {
    // The server sets the session cookie automatically.
    // Persist any kiosk-specific localStorage settings returned by the API.
    if (response.data.localStorage) {
      Object.keys(response.data.localStorage).forEach((key) => {
        const value = response.data.localStorage[key]
        localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value)
      })
    }

    return response.data
  }
}
